export const metadata = {
    title: "FreelanceGen – IT-Projekte finden in DACH als Freelancer",
    description: "Kostenlose Tools für Rechnungen, Verträge, CRM. KI-Matching für Projekte in Germany, Austria, Switzerland. No commissions, GDPR-konform.",
    keywords: "IT Freelancer Jobs DACH, freelance platform Germany, Rechnung generator Freelancer, Dienstvertrag Vorlage, IT jobs Freelancer",
    openGraph: {
        title: "FreelanceGen – IT-Projekte finden in DACH als Freelancer",
        description: "Kostenlose Tools für Rechnungen, Verträge, CRM. KI-Matching für Projekte in Germany, Austria, Switzerland. No commissions, GDPR-konform.",
        /*  url: 'https://freelancegen.de/freelancer',
          images: [{ url: '/og-freelancer.png' }],*/
    },

    canonical: "https://freelancegen.de/freelancer",
    alternates: {
        canonical: "https://freelancegen.de/freelancer",
    },
};

